import React from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { NavLink } from "react-router-dom";
import {
  FaHandshake,
  FaUserCog,
  FaCubes,
  FaTools,
} from "react-icons/fa";
import ServicesSection from "./components/ServicesSection";
import PartnerSection from "./components/PartnerSection";

const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <section
        style={{
          background: "linear-gradient(135deg, #0F0A1F, #240046)",
          color: "#ffffff",
          padding: isMobile ? "4.5rem 1.5rem" : isTablet ? "5.5rem 2rem" : "7rem 4rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isTablet ? "1fr" : "1.2fr 0.8fr",
              gap: isMobile ? "36px" : isTablet ? "42px" : "60px",
              alignItems: "center",
            }}
          >
            <div>
              <h1
                style={{
                  fontSize: isMobile ? "32px" : isTablet ? "44px" : "52px",
                  fontWeight: 700,
                  lineHeight: isMobile ? "42px" : isTablet ? "54px" : "64px",
                  marginBottom: "25px",
                }}
              >
                Building Reliable
                <br />
                <span style={{ color: "#9D4EDD" }}>
                  Enterprise Infrastructure
                </span>
              </h1>

              <p
                style={{
                  fontSize: isMobile ? "15px" : isTablet ? "17px" : "18px",
                  color: "#DCD6F7",
                  lineHeight: isMobile ? "28px" : "30px",
                  maxWidth: "650px",
                }}
              >
                InnoByte is a technology system integrator delivering end-to-end
                solutions across data centres, enterprise Wi-Fi, secure
                networking, electronics hardware, and digital infrastructure.
                We design, deploy, and support reliable environments built for
                scale, uptime, and operational efficiency.
              </p>

              <div
                style={{
                  marginTop: isMobile ? "32px" : "40px",
                  display: "flex",
                  gap: "18px",
                  flexWrap: "wrap",
                }}
              >
                <NavLink
  to="/services"
  style={{
    background: "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
    padding: isMobile ? "13px 22px" : "14px 28px",
    borderRadius: "8px",
    color: "#fff",
    textDecoration: "none",
    fontWeight: 600,
    boxShadow: "0 10px 25px rgba(157, 78, 221, 0.35)",
    width: isMobile ? "100%" : "auto",
    textAlign: "center",
  }}
>
  Explore Solutions
</NavLink>

<NavLink
  to="/contact"
  style={{
    border: "1px solid rgba(255,255,255,0.4)",
    padding: isMobile ? "13px 22px" : "14px 28px",
    borderRadius: "8px",
    color: "#DCD6F7",
    textDecoration: "none",
    fontWeight: 500,
    width: isMobile ? "100%" : "auto",
    textAlign: "center",
  }}
>
  Contact Us
</NavLink>
              </div>
            </div>

            <div
              style={{
                backgroundColor: "rgba(255,255,255,0.05)",
                padding: isMobile ? "26px" : isTablet ? "32px" : "40px",
                borderRadius: "16px",
                border: "1px solid rgba(255,255,255,0.1)",
                backdropFilter: "blur(8px)",
              }}
            >
              <div style={{ marginBottom: "25px" }}>
                <h3 style={{ color: "#9D4EDD", fontWeight: 600 }}>
                  End-to-End Integration
                </h3>
                <p style={{ color: "#DCD6F7", fontSize: "14px" }}>
                  Planning, procurement, implementation, and support under one
                  delivery model.
                </p>
              </div>

              <div style={{ marginBottom: "25px" }}>
                <h3 style={{ color: "#9D4EDD", fontWeight: 600 }}>
                  Data Centre & Network Readiness
                </h3>
                <p style={{ color: "#DCD6F7", fontSize: "14px" }}>
                  High-availability infrastructure for enterprise campuses,
                  server rooms, and critical facilities.
                </p>
              </div>

              <div>
                <h3 style={{ color: "#9D4EDD", fontWeight: 600 }}>
                  Field-Proven Execution
                </h3>
                <p style={{ color: "#DCD6F7", fontSize: "14px" }}>
                  On-site deployment expertise across structured cabling,
                  wireless, racks, power, and electronics hardware.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 4rem",
          background:
            "radial-gradient(circle at top left, rgba(157, 78, 221, 0.14), transparent 28%), radial-gradient(circle at top right, rgba(106, 13, 173, 0.1), transparent 24%), linear-gradient(180deg, #ffffff 0%, #f8f5ff 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: isMobile ? "24px" : "36px",
            left: isMobile ? "-10px" : "40px",
            width: isMobile ? "110px" : "180px",
            height: isMobile ? "110px" : "180px",
            borderRadius: "50%",
            background: "rgba(157, 78, 221, 0.08)",
            filter: "blur(22px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: isMobile ? "20px" : "30px",
            right: isMobile ? "-12px" : "50px",
            width: isMobile ? "120px" : "190px",
            height: isMobile ? "120px" : "190px",
            borderRadius: "50%",
            background: "rgba(80, 42, 140, 0.08)",
            filter: "blur(24px)",
          }}
        />
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              textAlign: "center",
              maxWidth: "760px",
              margin: "0 auto 50px auto",
            }}
          >
            <h2
              style={{
                fontSize: isMobile ? "28px" : "40px",
                fontWeight: 700,
                color: "#1E1B4B",
                marginBottom: "18px",
              }}
            >
              Why Choose Us
            </h2>

            <p
              style={{
                fontSize: isMobile ? "14px" : "16px",
                lineHeight: "28px",
                color: "#6B7280",
                margin: 0,
              }}
            >
              We simplify infrastructure delivery by combining planning,
              execution, and support through one accountable integration team.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "1fr"
                : "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "24px",
            }}
          >
            {[
              {
                icon: FaHandshake,
                title: "Single Vendor Coordination",
                desc: "One delivery partner for design, procurement, installation, and integration across multiple infrastructure layers.",
              },
              {
                icon: FaUserCog,
                title: "Certified Engineers",
                desc: "Skilled technical teams with hands-on experience across enterprise networking, cabling, electronics, and on-site deployment.",
              },
              {
                icon: FaCubes,
                title: "OEM Partnerships",
                desc: "Strong alignment with trusted technology brands to ensure solution fit, product reliability, and long-term support.",
              },
              {
                icon: FaTools,
                title: "Execution & Support",
                desc: "Practical on-site delivery, structured handover, and post-installation support for long-term system reliability.",
              },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  padding: isMobile ? "24px" : "28px",
                  borderRadius: "22px",
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,247,255,0.96) 100%)",
                  border: "1px solid rgba(157, 78, 221, 0.12)",
                  boxShadow: "0 14px 35px rgba(15, 10, 31, 0.06)",
                  transition: "transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 18px 40px rgba(106, 13, 173, 0.14)";
                  e.currentTarget.style.borderColor = "rgba(157, 78, 221, 0.26)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 14px 35px rgba(15, 10, 31, 0.06)";
                  e.currentTarget.style.borderColor = "rgba(157, 78, 221, 0.12)";
                }}
              >
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "18px",
                    background:
                      "linear-gradient(135deg, rgba(106, 13, 173, 0.14), rgba(157, 78, 221, 0.22))",
                    color: "#6A0DAD",
                    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
                  }}
                >
                  <item.icon size={24} />
                </div>

                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#6A0DAD",
                    marginBottom: "14px",
                    lineHeight: "28px",
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                    fontSize: "15px",
                    lineHeight: "26px",
                    color: "#4B5563",
                    margin: 0,
                  }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ServicesSection />
      <PartnerSection />
    </>
  );
};

export default Home;
